import { Typography } from "@mui/material";
import { styled } from "@mui/system";

export const CommonText = styled(Typography)`
  font-size: 14px;
`;
